export default {
  listaNegociadoresDoUsuario: [],
  listaPermissoesHabilitadasDoUsuario: [],
  listaMergeDasPermissoesDoUsuarioESistema: [],
  possuiNegociador: false,
  listaUnidadesDisponiveis: [],
  listaCoordenadoresDisponiveis: [],
  listaCapasDisponiveis: [],
  listaTiposDeAcaoDisponiveis: [],
  listaEstadosDisponiveis: [],
  dadosPerfil: [],
  dadosSalvosPerfilAdvogado: [],
  formulario: {
    f_id: null,
    f_name: null,
    f_username: null,
    f_sede: null,
    f_extension: '',
    f_role: null,
    f_password: null,
    f_password_confirm: null,
    f_status: 2,
    f_daysweek: [],
    f_birthday: null,
    f_office: null,
    f_email: null,
    f_hour_begin: '00:00',
    f_hour_end: '23:59',
    f_coordinator: false,
    f_reviewer: false,
    f_int_permissions: [],
    f_areas: [],
    f_permissions: [],
    f_profiles: [],
    f_profile_data: [],
    f_photo: []
  },
  dadosRetorno: {
    sucesso: false,
    mensagem: '',
    listaDeErros: []
  },
  flagsDeControle: {
    carregandoDados: {
      status: false,
      mensagem: ''
    },
    manipulandoDados: {
      status: false,
      mensagem: ''
    },
    avisoDeErroNoFormulario: {
      exibir: false,
      mensagem: ''
    }
  }
}
